<ag-shr-modal-window
  #updateAgencyLeadModalRef
  [width]="'80%'"
  [height]="'auto'"
  [actionTitle]="'Next'"
  [title]="modalTitleSig()"
  [inProgress]="inProgress$ | async"
  (onSaveClick)="handleSave()"
  [onCloseModal]="handleClosePopup"
>
  @if (updateAgencyLeadModalRef?.popupComponent?.visible) {
    <div>
      <dx-drop-down-box
        #dropDownBoxRef
        [labelMode]="'floating'"
        [label]="'Candidate'"
        [value]="formDataSig()?.candidate"
        [displayExpr]="AgentKeys.p_agent_name"
        [dataSource]="agentsDataSource"
        [validationMessagePosition]="'left'"
      >
        <div *dxTemplate="let data of 'content'">
          <dx-data-grid
            [dataSource]="agentsDataSource"
            [remoteOperations]="true"
            [syncLookupFilterValues]="false"
            [hoverStateEnabled]="true"
            [selectedRowKeys]="selectedCandidateKeySig()"
            (onSelectionChanged)="handleCandidateChange($event, dropDownBoxRef)"
            [filterValue]="defaultFilterSig()"
            height="100%"
          >
            <dxo-selection mode="single"></dxo-selection>
            <dxo-filter-row [visible]="false"></dxo-filter-row>
            <dxo-scrolling mode="virtual"></dxo-scrolling>

            <dxo-search-panel [visible]="true" [width]="240" placeholder="Search..."></dxo-search-panel>

            <dxo-filter-panel [visible]="true"></dxo-filter-panel>
            <dxo-filter-builder [allowHierarchicalFields]="true"></dxo-filter-builder>
            <dxo-filter-builder-popup></dxo-filter-builder-popup>

            <dxi-column [dataField]="AgentKeys.email_addresses" [visible]="false"> </dxi-column>
            <dxi-column [dataField]="AgentKeys.p_agent_first_name" [visible]="false"> </dxi-column>
            <dxi-column [dataField]="AgentKeys.p_agent_last_name" [visible]="false"> </dxi-column>

            <dxi-column
              *var="AgentKeys.p_agent_name as fieldName"
              [dataField]="fieldName"
              [caption]="fieldName | caption: 'agentsList'"
              dataType="string"
              [minWidth]="320"
            ></dxi-column>

            <dxi-column
              *var="AgentKeys.agent_type as fieldName"
              [dataField]="fieldName"
              [caption]="fieldName | caption: 'agentsList'"
              dataType="string"
              [minWidth]="320"
            >
              <dxo-lookup
                [dataSource]="AGENT_TYPE_LOOKUP"
                [valueExpr]="LookupKeys.value"
                [displayExpr]="LookupKeys.description"
                [allowClearing]="false"
              ></dxo-lookup>
            </dxi-column>

            <dxi-column
              *var="AgentKeys.p_agent_id as fieldName"
              [dataField]="fieldName"
              [caption]="fieldName | caption: 'agentsList'"
              dataType="string"
              [minWidth]="320"
            ></dxi-column>

            <dxi-column
              *var="AgentKeys.p_mga_id as fieldName"
              [dataField]="fieldName"
              [caption]="fieldName | caption: 'agentsList'"
              [minWidth]="200"
            >
              <dxo-lookup
                [dataSource]="mgasLookup$ | async"
                [allowClearing]="false"
                [displayExpr]="'name'"
                [valueExpr]="'agency_id'"
              >
              </dxo-lookup>
            </dxi-column>

            <dxi-column
              *var="AgentKeys.p_agency_id as fieldName"
              [dataField]="fieldName"
              [caption]="fieldName | caption: 'agentsList'"
              [minWidth]="200"
            >
              <dxo-lookup
                [dataSource]="agencies$ | async"
                [allowClearing]="true"
                [displayExpr]="'name'"
                [valueExpr]="'agency_id'"
              >
              </dxo-lookup>
            </dxi-column>

            <dxi-column
              *var="AgentKeys.is_manager as fieldName"
              [dataField]="AgentKeys.is_manager"
              [caption]="fieldName | caption: 'agentsList'"
              width="100"
            >
              <dxo-lookup
                [dataSource]="TRUE_FALSE_LOOKUP"
                [allowClearing]="false"
                [valueExpr]="LookupKeys.value"
                [displayExpr]="LookupKeys.description"
              ></dxo-lookup>
            </dxi-column>
          </dx-data-grid>
          <!-- <dx-tree-view
            [dataSource]="directoriesSig()"
            [dataStructure]="'plain'"
            [keyExpr]="BaseModelKeys.dbId"
            [parentIdExpr]="'parentId'"
            [displayExpr]="FileDirectoryKeys.name"
            selectionMode="single"
            [selectByClick]="true"
            (onItemClick)="onTreeItemClick($event)"
          ></dx-tree-view> -->
        </div>
        <dx-validator [validationGroup]="validationGroup">
          <dxi-validation-rule
            type="required"
            message="Candidate is required."
            [reevaluate]="false"
          ></dxi-validation-rule>

          <dxi-validation-rule
            type="custom"
            [validationCallback]="hasAgentIdValidationCallback"
            message="This candidate must have Agent Id assigned."
            [reevaluate]="false"
          ></dxi-validation-rule>

          <dxi-validation-rule
            type="custom"
            [validationCallback]="isMgaMatchValidationCallback"
            message="This candidate is not part of the required MGA."
            [reevaluate]="false"
          ></dxi-validation-rule>

          <dxi-validation-rule
            type="custom"
            [validationCallback]="isAgencyMatchValidationCallback"
            message="This candidate is not part of the required Agency."
            [reevaluate]="false"
          ></dxi-validation-rule>

          <dxi-validation-rule
            type="custom"
            [validationCallback]="isCandidateTeamLeadValidationCallback"
            message="This candidate must be a Team Lead for this role."
            [reevaluate]="false"
          ></dxi-validation-rule>

          <dxi-validation-rule
            type="custom"
            [validationCallback]="isAgentTypeMatchRequirementsValidationCallback"
            message="This candidate’s Agent Type doesn’t meet the position requirements."
            [reevaluate]="false"
          ></dxi-validation-rule>
        </dx-validator>
      </dx-drop-down-box>

      <dx-validation-summary
        class="update-agency-lead-modal__validation-summary"
        [validationGroup]="validationGroup"
      ></dx-validation-summary>

      <!-- <dx-validator [validationGroup]="validationGroup">
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dx-validator> -->

      <!-- <div class="mt-2">
        @if (formDataSig()?.candidate; as candidate) {
          @if (selectedCandidateValidationResultsSig()?.length) {
            <p class="mt-2">
              <i> Please resolve following issues before continuing: </i>
            </p>
          }
          <div class="mt-2">
            @for (item of selectedCandidateValidationResultsSig(); track $index) {
              <p class="mt-1">{{ item }}</p>
            }
          </div>
        } @else {
          <span>
            <i>Select Candidate to see details</i>
          </span>
        }
      </div> -->
    </div>
  }
</ag-shr-modal-window>
